import { config } from "./config";
import { tokens } from "./tokens";
import axios from "axios";
import { handleAxiosError } from "./utils/error.utils";
import { UnexpectedAPIError } from "./errors";
export const reset = (() => {
    async function request(id) {
        try {
            const url = `${baseUrl()}/request`;
            const data = { id };
            const response = await axios.post(url, data);
            return response.data;
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    async function confirm(token, password) {
        // start with clean axios, no interceptors
        const _axios = axios.create();
        try {
            const url = `${baseUrl()}/confirm`;
            const data = { password };
            const config = { headers: { Authorization: `Bearer ${token}` } };
            const response = await _axios.post(url, data, config);
            return tokens.set(response.headers);
        }
        catch (error) {
            if (error.response)
                handleAxiosError(error.response);
            else
                throw UnexpectedAPIError;
        }
    }
    function baseUrl() {
        return `${config.fullUrl()}/loginlink`;
    }
    return {
        request: request,
        confirm: confirm,
    };
})();
